import Vue from "vue";
import Router from "vue-router";
import list from "../pages/kol-list";
import content from "../pages/content";
import login from "../pages/login"
import daren from "../pages/daren";
import detail from "../pages/detail";
import helper from "../pages/helper";
import same from "../pages/same";
import cooperationDetail from "../pages/detail/cooperationDetail";
import liveBroadcastDetail from "../pages/detail/liveBroadcastDetail";
import shortVideoDetail from "../pages/detail/shortVideoDetail";
import drliveDetail from "../pages/detail/drLiveDetail";
import drcpmDetail from "../pages/detail/drCpmDetail";
import kuaishou from "../pages/kuaishou";
import orderRecommend from "../pages/orderRecommend";
import ksHelper from "../pages/helper/ksHelper.vue";
import bzhan from "../pages/bzhan";
import searchTopic from "../pages/searchTopic/index.vue";
import liveTalentList from "../pages/live-talent-list/index.vue";
import talentMonthly from "../pages/talent-monthly/index.vue";
import hostsSquare from "../pages/hosts-square/index.vue";
import notRecommended from "../pages/not-Recommended/index.vue";

Vue.use(Router);



export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: login
    },
    {
      path: '/',
      name: 'content',
      component: content,
      children: [
        {
          path: "/list",
          name: 'list',
          component: list,
        },
        {
          path: "/hosts-square",
          name: 'hosts-square',
          component: hostsSquare,
        },
        {
          path: "/live-talent",
          name: 'liveTalent',
          component: liveTalentList,
        },
        {
          path: "/talent-monthly",
          name: 'talentMonthly',
          component: talentMonthly,
        },
        {
          path: "/not-recommended",
          name: 'notRecommended',
          component: notRecommended,
        },

        {
          path: "/ai",
          name: 'ai',
          component: helper,
        },
        {
          path: "/same",
          name: 'same',
          component: same,
        },
        {
          path: "/ks",
          name: 'kuaishou',
          component: kuaishou,
        },
        {
          path: "/bl",
          name: 'bzhan',
          component: bzhan,
        },
        {
          path: "/orderRecommend",
          name: 'orderRecommend',
          component: orderRecommend,
        },
        {
          path: "/ksHelper",
          name: 'ksHelper',
          component: ksHelper,
        },
        {
          path: "/inquiryMatch",
          name: 'inquiryMatch',
          component: () => import('@/pages/inquiry-match/index.vue'),
        },
        {
          path: "/inquiryQuickRecommendations",   //询单快速推荐
          name: 'inquiryQuickRecommendations',
          component: () => import('@/pages/inquiry-quick-recommendations/index.vue'),
        },
        {
          path: "/profit-calculator",   //利润计算器
          name: 'profitCalculator',
          component: () => import('@/pages/profit-calculator/index.vue'),
        },
        {
          path: "/talent-fast-search",   //达人快搜
          name: 'talentFastSearch',
          component: () => import('@/pages/talent-fast-search/index.vue'),
        },
        {
          path: "/shopping-cart",   //达人清单（达人购物车）
          name: 'shoppingCart',
          component: () => import('@/pages/shopping-cart/index.vue'),
        },
        {
          path: "/schedule-dashboard",   //资产账号档期
          name: 'scheduleDashboard ',
          component: () => import('@/pages/dashboard/scheduleDashboard.vue'),
        },
        {
          path: "/newLiveTalentDetail", //直播详情页
          name: 'newLiveTalentDetail',
          component: () => import('@/pages/liveDetail/Index.vue'),
        },
        {
          path: "/schedule-relation-order",   //档期与订单关联情况
          name: 'scheduleRelationOrder',
          component: () => import('@/pages/dashboard/scheduleRelationOrder.vue'),
        },
        {
          path: "/institutional-cooperation-policy",   //机构合作政策
          name: 'institutionalCooperationPolicy',
          component: () => import('@/pages/institutional-cooperation-policy/index.vue'),
        },
      ]
    },
    {
      path: '/searchTopic',
      component: content,
      redirect: '/searchTopic/index/search',
      children: [
        {
          path: "index",
          name: 'searchTopic',
          component: searchTopic,
          children: [
            {
              path: "search",
              component: () => import('../pages/searchTopic/Search.vue'),
            },
            {
              path: "list",
              name: 'searchList',
              component: () => import('../pages/searchTopic/searchList.vue'),
            },
            {
              path: 'topic-list',
              component: () => import('../pages/searchTopic/TopicList.vue')
            }
          ],
        },

      ]

    },
    {
      path: '/daren',
      name: 'daren',
      component: daren
    },
    {
      path: "/rednote",
      name: 'rednote',
      component: () => import('@/pages/rednote/index.vue'),
    },
    {
      path: "/otherPlatform",
      name: 'otherPlatform',
      component: () => import('@/pages/otherPlatform/index.vue'),
    },
    {
      path: "/live-talent-detail",
      name: 'liveTalentDetail',
      component: () => import('./../pages/LiveTalentDetail/index.vue'),
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail,
    },{
      path: '/cooperationDetail',
      name: 'cooperationDetail',
      component: cooperationDetail
    },{
      path: '/liveBroadcastDetail',
      name: 'liveBroadcastDetail',
      component: liveBroadcastDetail
    },{
      path: '/shortVideoDetail',
      name: 'shortVideoDetail',
      component: shortVideoDetail
    },
    {
      path: "/drliveDetail",
      name: 'drliveDetail',
      component: drliveDetail,
    },
    {
      path: "/drcpmDetail",
      name: 'drcpmDetail',
      component: drcpmDetail,
    }
  ]
});
